import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  headersBase,
  headersType,
} from "../../../utils/constants/headersForApi";

export const practiceTaskApi = createApi({
  reducerPath: "practiceTasks",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  tagTypes: ["practiceTasks", "practiceTask"],
  endpoints: (builder) => ({
    getPracticeTasks: builder.query({
      query: (params) => {
        const {
          startRow = 0,
          endRow = 100,
          filter = {},
          sort = [],
          practiceId = "",
        } = params;

        return {
          url: `/admin/PracticeTask/list?practiceId=${practiceId}`,
          method: "POST",
          headers: headersType(),
          body: {
            startRow,
            endRow,
            filter,
            sort,
          },
        };
      },
      providesTags: ["practiceTasks"],
      // Trasformazione della risposta per estrarre i dati correttamente
      transformResponse: (response) => {
        return {
          items: response.Data?.items || [],
          count: response.Data?.count || 0,
          Success: response.Result === 1,
        };
      },
    }),
    getPracticeTaskById: builder.query({
      query: (id) => ({
        url: `/admin/PracticeTask/${id}`,
        method: "GET",
        headers: headersBase(),
      }),
      providesTags: (result, error, id) => [{ type: "practiceTask", id }],
    }),
    createPracticeTask: builder.mutation({
      query: (practiceTask) => ({
        url: `/admin/PracticeTask`,
        method: "POST",
        headers: headersType(),
        body: practiceTask,
      }),
      invalidatesTags: ["practiceTasks"],
    }),
    updatePracticeTask: builder.mutation({
      query: ({ id, ...practiceTask }) => ({
        url: `/admin/PracticeTask/${id}`,
        method: "PUT",
        headers: headersType(),
        body: practiceTask,
      }),
      invalidatesTags: (result, error, { id }) => [
        "practiceTasks",
        { type: "practiceTask", id },
      ],
    }),
    deletePracticeTask: builder.mutation({
      query: (id) => ({
        url: `/admin/PracticeTask/${id}`,
        method: "DELETE",
        headers: headersBase(),
      }),
      invalidatesTags: (result, error, id) => [
        "practiceTasks",
        { type: "practiceTask", id },
      ],
    }),
  }),
});

export const {
  useGetPracticeTasksQuery,
  useGetPracticeTaskByIdQuery,
  useCreatePracticeTaskMutation,
  useUpdatePracticeTaskMutation,
  useDeletePracticeTaskMutation,
} = practiceTaskApi;
